const React = require('react')
const { useState, useEffect } = require('react')
const {
    Sparkles,
    MessageSquare,
    ArrowRight,
    Brain,
    Zap,
    Heart,
    CheckCircle2,
    Users,
    Calendar,
} = require('lucide-react')
const PropTypes = require('prop-types')
const Page = require('app/page')
// const VendastaChatWidget = require('component/VendastaChatWidget')
const withStyles = require('withStyles').default
const styles = require('./home_ai.less')
const radio = require('lib/radio')
const log = require('log').create('home') // eslint-disable-line

class Home extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            google: null,
            facebook: null,
        }
    }

    componentDidMount() {
        this.showBanner()
        this.sendMetrics()
        this.initializeListeners()
        this.initializeOnboardingController()
    }

    showBanner() {
        const { missing_user_name } = this.props
        if (!missing_user_name) return

        require.ensure(
            [],
            () => {
                const Dialog = require('module/dialog/dialog')

                const text = `There is no one by the name ‘${missing_user_name}’. Please check the name and try again.`
                Dialog.banner({
                    text,
                })
            },
            'homepage',
        )
    }

    sendMetrics() {
        radio.metrics_signup.trigger('homepage:visit')
    }

    initializeListeners() {
        radio.auth.on('facebook:failed', () => {
            this.setState({
                facebook: false,
            })
        })
        radio.auth.on('google:failed', () => {
            this.setState({
                google: false,
            })
        })
        radio.auth.on('facebook:loaded', () => {
            this.setState({
                facebook: true,
            })
        })
        radio.auth.on('google:initialized', () => {
            this.setState({
                google: true,
            })
        })
    }

    initializeOnboardingController() {
        require.ensure(
            [],
            () => {
                const $ = require('lib/jquery')
                const OnboardingController = require('../home/onboarding_controller')
                // need to initiate with all google signup node
                this.onboarding_controller = new OnboardingController({
                    google_button: $('.social-button.google'),
                })
            },
            'home_onboarding',
        )
    }

    render() {
        const nav_props = {
            link_logo: false,
            signup_button_props: {
                href: '/signup/email',
                desktop_text: 'Get your free page',
                mobile_text: 'Get your page',
                onClick: (e) => {
                    e.preventDefault()
                    this.onboarding_controller.onClickSignupEmail()
                },
            },
        }

        return (
            <Page nav_props={nav_props} className={styles.scope}>
                {/* <main className="main"> */}
                <section className={`hero-section visible`}>
                    <div className="hero-content">
                        <div className="hero-badge">
                            <Sparkles />
                            <span>The Next Evolution of Your Profile</span>
                        </div>

                        <h1 className="hero-title">
                            MEET YOUR
                            <br />
                            <span className="hero-title-gradient">AI TWIN</span>
                        </h1>

                        <p className="hero-subtitle">
                            The next evolution of your about.me page.
                            <br />
                            Now alive and interactive.
                        </p>

                        <div className="hero-chat-box">
                            <div className="hero-chat-content">
                                <div className="hero-chat-avatar">
                                    <MessageSquare />
                                </div>
                                <div className="hero-chat-text">
                                    <p>
                                        "Hey! You're chatting with <span className="highlight">Virtual Brad</span>.
                                        Trained to think, talk, and know everything Brad does. Ask away!"
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="hero-cta-container">
                            <a href="/signup/start">
                                <button className="hero-cta-button">
                                    Get Started
                                    <ArrowRight />
                                </button>
                            </a>
                        </div>

                        <div className="hero-image-container">
                            <div className="browser-window">
                                <div className="browser-header">
                                    <div className="browser-url-bar">
                                        <span className="browser-url">about.me/bfeld</span>
                                    </div>
                                </div>
                                <img
                                    src={require('./images/brad2.jpg')}
                                    alt="AI Twin Example - Virtual Brad chatbot interface"
                                    className="hero-image"
                                />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="feature-cards-section">
                    <div className="feature-cards-grid">
                        <div className="feature-card">
                            <div className="feature-card-icon blue">
                                <Brain />
                            </div>
                            <h3>Don't just show who you are.</h3>
                            <p>Let people talk to your AI-powered self.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-card-icon emerald">
                                <Zap />
                            </div>
                            <h3>Your Page, Reimagined.</h3>
                            <p>Your page still looks the same — beautiful and simple — but now it talks back.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-card-icon violet">
                                <Heart />
                            </div>
                            <h3>Visitors can chat directly.</h3>
                            <p>Your AI Twin helps them learn about you, your work, and what you offer.</p>
                        </div>
                    </div>
                </section>

                <section id="features" className="features-section">
                    <div className="features-grid">
                        <div className="features-text">
                            <h2>
                                Professional <br />
                                But Smarter.
                            </h2>
                            <p>
                                Build trust and authority with an AI Twin that knows your background, answers questions,
                                and introduces you even when you're not online.
                            </p>
                        </div>
                        <div className="features-visual blue">
                            <div className="features-list">
                                {[
                                    'Available 24/7',
                                    'Instant responses',
                                    'Builds credibility',
                                    'Never misses a lead',
                                ].map((item, i) => (
                                    <div key={i} className="features-list-item">
                                        <CheckCircle2 />
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="features-grid reverse">
                        <div className="features-visual emerald">
                            <div className="features-list">
                                {[
                                    'Speaks in your tone',
                                    'Shares your story',
                                    'Reflects your personality',
                                    'Represents you authentically',
                                ].map((item, i) => (
                                    <div key={i} className="features-list-item">
                                        <CheckCircle2 />
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="features-text">
                            <h2>
                                Authentic <br />
                                The Real You, Amplified.
                            </h2>
                            <p>
                                Your Twin speaks in your tone and represents your personality. From your passions to
                                your professional story — it shares what makes you, you.
                            </p>
                        </div>
                    </div>

                    <div className="features-grid">
                        <div className="features-text">
                            <h2>
                                Simple <br />
                                Because AI Should Feel Effortless.
                            </h2>
                            <p>
                                Create your page once. Your AI Twin does the rest — chatting with visitors, answering
                                questions, and collecting leads automatically.
                            </p>
                            <a href="/signup/start">
                                <button className="hero-cta-button">
                                    Get Started
                                    <ArrowRight />
                                </button>
                            </a>
                        </div>
                        <div className="features-visual violet">
                            <div className="features-steps">
                                <div className="features-step">
                                    <div className="features-step-number">
                                        <span>1</span>
                                    </div>
                                    <div>
                                        <h4>Create your page once</h4>
                                        <p>Set up your profile in minutes</p>
                                    </div>
                                </div>
                                <div className="features-step">
                                    <div className="features-step-number">
                                        <span>2</span>
                                    </div>
                                    <div>
                                        <h4>Train your Twin</h4>
                                        <p>Teach it about you and your work</p>
                                    </div>
                                </div>
                                <div className="features-step">
                                    <div className="features-step-number">
                                        <span>3</span>
                                    </div>
                                    <div>
                                        <h4>Let it work for you</h4>
                                        <p>Your Twin handles the rest automatically</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="how-it-works" className="how-it-works-section">
                    <div className="how-it-works-container">
                        <div className="how-it-works-header">
                            <h2>What Makes the Virtual Twin Powerful</h2>
                            <p>Three powerful features that transform how people connect with you</p>
                        </div>

                        <div className="how-it-works-grid">
                            <div className="how-it-works-card">
                                <div className="how-it-works-card-icon blue">
                                    <Brain />
                                </div>
                                <h3>Train It Your Way</h3>
                                <p>
                                    Personalize your AI Twin. Teach it how to talk about you — your skills, your bio,
                                    your goals.
                                </p>
                            </div>

                            <div className="how-it-works-card">
                                <div className="how-it-works-card-icon emerald">
                                    <Users />
                                </div>
                                <h3>Capture Leads Automatically</h3>
                                <p>
                                    Your Twin can collect contact info from conversations and store it directly in your
                                    built-in CRM.
                                </p>
                            </div>

                            <div className="how-it-works-card">
                                <div className="how-it-works-card-icon violet">
                                    <Calendar />
                                </div>
                                <h3>Book Meetings</h3>
                                <p>Connect Twin with your calendar to schedule meetings automatically.</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="pricing-section">
                    <div className="pricing-header">
                        <h2>Upgrade — Bring Your Page to Life.</h2>
                        <p>
                            Unlock your AI Virtual Twin and turn your static page into a living, conversational
                            experience.
                        </p>
                    </div>

                    <div className="pricing-grid">
                        <div className="pricing-card">
                            <h3>Free</h3>
                            <div className="pricing-price">
                                <span className="pricing-price-amount">$0</span>
                                <span className="pricing-price-period">/yr</span>
                            </div>
                            <ul className="pricing-features">
                                <li className="pricing-feature">
                                    <CheckCircle2 />
                                    <span>about.me page</span>
                                </li>
                                <li className="pricing-feature">
                                    <CheckCircle2 />
                                    <span>Email signature</span>
                                </li>
                            </ul>
                            <a href="/signup/start">
                                <button className="pricing-button secondary">Get Started</button>
                            </a>
                        </div>

                        <div className="pricing-card">
                            <h3>Standard</h3>
                            <div className="pricing-price">
                                <span className="pricing-price-amount">$6</span>
                                <span className="pricing-price-period">/mo</span>
                                <div className="pricing-price-yearly">or $60/yr</div>
                            </div>
                            <ul className="pricing-features">
                                <li className="pricing-feature">
                                    <CheckCircle2 />
                                    <span>about.me page</span>
                                </li>
                                <li className="pricing-feature">
                                    <CheckCircle2 />
                                    <span className="bold">AI Virtual Twin</span>
                                </li>
                                <li className="pricing-feature">
                                    <CheckCircle2 />
                                    <span>
                                        Capture leads directly into about.me{' '}
                                        <a href="https://www.vendasta.com/glossary/crm-software/">CRM</a> for easy
                                        follow-up
                                    </span>
                                </li>
                                <li className="pricing-feature">
                                    <CheckCircle2 />
                                    <span>Schedule appointments</span>
                                </li>
                                <li className="pricing-feature">
                                    <CheckCircle2 />
                                    <span>Email signature</span>
                                </li>
                            </ul>
                            <a href="/signup/start">
                                <button className="pricing-button primary">Get Your Virtual Twin</button>
                            </a>
                        </div>

                        <div className="pricing-card featured">
                            <div className="pricing-badge">Most Popular</div>
                            <h3>Pro</h3>
                            <div className="pricing-price">
                                <span className="pricing-price-amount">$9</span>
                                <span className="pricing-price-period">/mo</span>
                                <div className="pricing-price-yearly">or $90/yr</div>
                            </div>
                            <ul className="pricing-features">
                                <li className="pricing-feature">
                                    <CheckCircle2 />
                                    <span>about.me page</span>
                                </li>
                                <li className="pricing-feature">
                                    <CheckCircle2 />
                                    <span className="bold">Virtual Twin AI</span>
                                </li>
                                <li className="pricing-feature">
                                    <CheckCircle2 />
                                    <span>
                                        Capture leads directly into about.me{' '}
                                        <a href="https://www.vendasta.com/glossary/crm-software/">CRM</a> for easy
                                        follow-up
                                    </span>
                                </li>
                                <li className="pricing-feature">
                                    <CheckCircle2 />
                                    <span>Schedule appointments</span>
                                </li>
                                <li className="pricing-feature">
                                    <CheckCircle2 />
                                    <span>Email signature</span>
                                </li>
                                <li className="pricing-feature">
                                    <CheckCircle2 />
                                    <span>Connect a domain (yourname.com)</span>
                                </li>
                                <li className="pricing-feature">
                                    <CheckCircle2 />
                                    <span>Customizable Spotlight button</span>
                                </li>
                                <li className="pricing-feature">
                                    <CheckCircle2 />
                                    <span>Image gallery or video embed</span>
                                </li>
                                <li className="pricing-feature">
                                    <CheckCircle2 />
                                    <span>Remove about.me branding</span>
                                </li>
                                <li className="pricing-feature">
                                    <CheckCircle2 />
                                    <span>Customer support</span>
                                </li>
                            </ul>
                            <a href="/signup/start">
                                <button className="pricing-button featured">
                                    Get Your Virtual Twin
                                    <Sparkles />
                                </button>
                            </a>
                        </div>
                    </div>
                </section>
                {/* </main> */}
            </Page>
        )
    }
}

Home.propTypes = {
    missing_user_name: PropTypes.string,
    variant: PropTypes.string,
}

Home.defaultProps = {
    missing_user_name: '',
    variant: '',
}

/* munges data necessary for building the page
@param props (Object) - props returned to the callback of react-router's match
@param pageData (Object) - data that is sent to ServerPage for rendering
@param dataResults (Object) - data returned from from server/lib/data_sources.js
    the keys of this data are defined by the keys you specify in the return of
    getDataRequirements
*/
function getPageData(props, pageData, dataResults) {
    // title
    pageData.title = 'about.me | your personal homepage'
    pageData.metas.push({
        name: 'og:title',
        content: pageData.title,
    })
    pageData.metas.push({
        name: 'twitter:title',
        content: pageData.title,
    })

    // facebook-specific
    pageData.metas.push({
        name: 'og:site_name',
        content: 'about.me',
    })
    pageData.metas.push({
        name: 'og:locale',
        content: 'en_US',
    })
    pageData.metas.push({
        name: 'og:url',
        content: 'https://about.me',
    })
    pageData.metas.push({
        name: 'og:type',
        content: 'aboutme_prod:page',
    })
    pageData.metas.push({
        name: 'fb:app_id',
        content: '249413078192',
    })

    // twitter-specific
    pageData.metas.push({
        name: 'twitter:site',
        content: '@aboutdotme',
    })
    pageData.metas.push({
        name: 'twitter:card',
        content: 'summary',
    })
    pageData.metas.push({
        name: 'twitter:url',
        content: 'https://about.me',
    })

    // meta descriptions
    const meta_description = 'Create your free, one-page website in just a few minutes.'
    pageData.metas.push({
        name: 'description',
        content: meta_description,
    })
    pageData.metas.push({
        name: 'og:description',
        content: meta_description,
    })
    pageData.metas.push({
        name: 'twitter:description',
        content: meta_description,
    })

    // images
    // using 'facebook' image for both because it's square
    // twitter card is using 'summary' type (not 'photo'), which has square image
    pageData.metas.push({
        name: 'og:image',
        content: require('images/logos/social.png'),
    })
    pageData.metas.push({
        name: 'twitter:image',
        content: require('images/logos/social.png'),
    })
    pageData.metas.push({
        name: 'twitter:image:alt',
        content: 'about.me logo',
    })

    return pageData
}

const StyledHome = withStyles(styles)(Home)
StyledHome.getPageData = getPageData

module.exports = StyledHome
